import React, { useRef, useEffect } from "react";
import styles from "./standaloneMathLive.module.css";
import "mathlive";

const StandaloneMathLive = ({ onSubmit, closePopup, value }) => {
  const mathFieldRef = useRef(null);

  const handleSubmit = () => {
    onSubmit(mathFieldRef.current.getValue());
  };

  useEffect(() => {
    if (mathFieldRef.current) {
      mathFieldRef.current.focus();
    }
  }, []);

  return (
    <div
      style={{ display: "flex", alignItems: "center" }}
      className={styles.standaloneMathLive}
    >
      <math-field
        ref={mathFieldRef}
        className="standalone-math-live"
        style={{
          border: "1px solid #ccc",
          minWidth: "150px",
          minHeight: "30px",
          borderRadius: "4px",
        }}
        value={value}
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            event.preventDefault();
            handleSubmit();
            closePopup();
          }
          if (event.key === "Escape") {
            event.preventDefault();
            closePopup();
          }
        }}
      ></math-field>
    </div>
  );
};

export default StandaloneMathLive;
